import isMobile from "is-mobile";

import { trackEvent } from "/services/bigbrain-service";
import { getCookie } from "/services/cookies-service";
import { normalizeUrl } from "/utils/url";

const GOOGLE_ANALYTICS_TO_EVENT_MAP = {
  "/lp/mzm/manything-video/": {
    testName: "mobile_long_lp_ab_test",
    variant: "old_mzm_lp"
  },
  "/test/fb-long/may/": {
    testName: "mobile_long_lp_ab_test",
    variant: "new_may_lp"
  },
  "/test/fb-long/dotan/": {
    testName: "mobile_long_lp_ab_test",
    variant: "new_dotan_lp"
  },
  "/": {
    testName: "old_hp_footer_ab_test",
    variant: "existing_hp"
  },
  "/simple-hp/": {
    testName: "old_hp_footer_ab_test",
    variant: "old_with_footer"
  },
  "/simple-hp-2/": {
    testName: "old_hp_footer_ab_test",
    variant: "old_no_footer"
  }
};

const isWithSoftSignup = () => {
  return !!getCookie("soft_signup_user_id") || !!getCookie("monday_active_account_slugs");
};

const isInGoogleExp = () => {
  return document.location.search.indexOf("utm_expid") > -1;
};

const performOptionalActions = (testName, variant, options) => {
  const { sendBigBrainEvent, addClassToDocument, eventName, info1 } = options;

  if (sendBigBrainEvent) {
    trackEvent(eventName || testName, { ab_test: variant, info1: info1 });
  }

  if (addClassToDocument && typeof document !== undefined) {
    const abTestClassName = `${testName}_${variant}`;
    document.documentElement.className += " " + abTestClassName;
  }
};

const isValidDeviceScopeForTest = (deviceScope) => {
  if (deviceScope === "desktop_only") {
    return !isMobile();
  } else if (deviceScope === "mobile_only") {
    return isMobile();
  } else {
    return true;
  }
};

export const trackAnalyticsTests = (location) => {
  location = normalizeUrl(location);
  const data = GOOGLE_ANALYTICS_TO_EVENT_MAP[location];
  if (!data) return;
  if (!isInGoogleExp()) return;
  if (isWithSoftSignup()) return;
  if (!isValidDeviceScopeForTest(data.deviceScope)) return;

  performOptionalActions(data.testName, data.variant, {
    sendBigBrainEvent: true,
    addClassToDocument: true,
    info1: data.info1
  });
};
